import { PcApiResponse } from '@/api/pc-api/types';
import { BizTargetType } from '@/constants/bizTargetType';
import { BizType } from '@/constants/bizType';
import { Role } from '@/constants/role';
import { api } from '@/utils/api';

export type LNBMyBizListItem = {
  authInfoId: string;
  bizTargetType: BizTargetType;
  bizType: BizType;
  dealerCompanyName?: string;
  dealerId?: string;
  partnerCompanyName?: string;
  partnerId?: string;
  role: Role;
};

export const getMyBizListLNB = (companyName: string) => {
  return api<PcApiResponse<LNBMyBizListItem[]>>('get', '/pc-api/v2/mybiz/list/lnb', { companyName });
};
